/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useNavigate } from "react-router-dom";
import Header from "./Header";

const PlanAccess = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    // Go back or navigate to a specific route
    navigate(-1); // Go back to previous page
    // Or use navigate("/dashboard") if you want to go to a fixed page
  };

  return (
    <section className="container-fluid">
      <div className="overlay"></div>
      <div className="drawer small">
        <div className="d-flex justify-content-start">
  <button
    className="btn p-0 close d-inline-flex"
    onClick={handleClose}
    style={{ background: "transparent", border: "none" }}
  >
   <i className="material-symbols-outlined">arrow_back</i>
  </button>
</div>

        <div className="alert-wrap text-center">
          <img
            className="ico mb-4"
            src="/assets/images/alert-locked-ico.svg"
            alt="locked"
          />
          <h1 className="mb-4">Feature Locked!</h1>
          <h6 className="mid-gray mb-6" style={{ lineHeight: "2" }}>
            This Feature Isn’t Available in Your Current Plan –
             Upgrade to Continue.
          </h6>
          <button
            className="btn btn-cancel rounded-5"
            onClick={() => navigate("/subscription")}
          >
            Back to Subscription
          </button>
        </div>
      </div>
    </section>
  );
};

export default PlanAccess;
